/**
 * 各カテゴリの料金一覧直下に置く共通の注記欄。
 * 見出しは共通の「ご案内・注意事項」。Ivory/Warm White 背景＋細い Greige 罫線＋Charcoal 文字で、
 * 警告ボックスのように強く見せない。
 */
export default function PriceNotice({ items }: { items?: string[] }) {
  if (!items || items.length === 0) return null;

  return (
    <section
      aria-label="ご案内・注意事項"
      className="border border-foreground-950/12 bg-background-100/60 px-6 py-6 md:px-8 md:py-7"
    >
      <h3 className="font-heading text-[13px] tracking-[0.04em] text-foreground-900">ご案内・注意事項</h3>
      <span aria-hidden className="mt-3 block h-px w-8 bg-accent-500" />
      <ul className="mt-4 space-y-2.5">
        {items.map((item) => (
          <li key={item} className="flex gap-3 text-[12px] leading-[1.95] text-foreground-600">
            <span aria-hidden className="mt-[8px] h-1 w-1 shrink-0 rounded-full bg-secondary-500" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}